import { ConfigService } from './../../cart-process/config.service';
import { Injectable } from '@angular/core';
import {
  NotificationProviderService,
  NotificationProviderTypeEnum
} from '../../external-interfaces/notification-provider.service';
import { OfferSwitcherTypeEnum } from '../../models/cartDetails/offerSwitcherType.model';
import { CommonInfoService } from '../../cart-process/common-info.service';
import { LoadersService } from '../../utils/loaders/loaders.service';
import { LoaderActions } from '../../utils/loaders/loader-actions.enum';
import { AppInjector } from '../../utils/services/set-app-injector';
import { IServerResponseResponse } from '../../interfaces/server-response.interface';
import { BrandTypeEnum } from '../../models/cartDetails/brand-type.enum';

@Injectable()
export default class B2bB2cFormSwitcherService {
  public showSwitcher = false;
  public switchTypes = OfferSwitcherTypeEnum;
  public selectedType: OfferSwitcherTypeEnum;
  public brandVirgin: boolean;

  private endpoint: any = AppInjector.get('Endpoint');

  constructor(
    private notificationProvider: NotificationProviderService,
    private loaderService: LoadersService
  ) {
    this.notificationProvider.subscribe(
      NotificationProviderTypeEnum.CART_DETAILS,
      (cartDetails: any) => {
        this.setSwitcherVisibility(cartDetails.possibleSwitch);
      }
    );

    this.notificationProvider.subscribe(
      NotificationProviderTypeEnum.COMMON_INFO,
      (commonInfo: CommonInfoService) => {
        this.selectedType = commonInfo.b2c ? OfferSwitcherTypeEnum.INDIVIDUAL : OfferSwitcherTypeEnum.BUSINESS;
      }
    );

    this.notificationProvider.subscribe(
      NotificationProviderTypeEnum.CONFIG,
      (config: ConfigService) => {
        if (config) {
        this.brandVirgin = config.brand === BrandTypeEnum.VIRGIN;
        }
      }
    );
  }

  public changeType(): void {
    this.loaderService.start(
      LoaderActions.MODAL_LOADER,
      {
        message: '',
        preventClose: true
      },
      true
    );

    this.endpoint('newCart.switch')
      .requestData({
        bundleNo: this.selectedType
      })
      .run()
      .then((response: IServerResponseResponse) => {
        this.notificationProvider.publish(
          NotificationProviderTypeEnum.CART_DETAILS,
          response
        );
      })
      .finally(() => this.loaderService.stop(LoaderActions.MODAL_LOADER));
  }

  private setSwitcherVisibility(showSwitcher: boolean = false): void {
    this.showSwitcher = showSwitcher;
  }
}
